module.exports = __webpack_public_path__ + "static/media/dark.f6d512ec.svg";